import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var LogoPlusPill = function LogoPlusPill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 24,
    fill: "url(#logo-plus-pill_svg__a)",
    rx: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 16,
    r: 2,
    fill: "url(#logo-plus-pill_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 16.138c.623-2.872 1.128-3.377 4-4-2.872-.623-3.377-1.128-4-4-.623 2.872-1.128 3.377-4 4 2.872.623 3.377 1.128 4 4m8 4.5h2.145v-4.862c.663.53 1.448.753 2.302.753 2.442 0 4.395-1.918 4.395-4.263 0-2.362-1.953-4.246-4.395-4.246-.854 0-1.64.223-2.302.754v-.6H18zm2.145-8.27v-.187c.052-1.147 1.064-2.14 2.302-2.14 1.256 0 2.285 1.027 2.285 2.225 0 1.216-1.03 2.243-2.285 2.243-1.238 0-2.25-.976-2.302-2.14m12.874 4.023v-1.866c-.122.017-.262.017-.331.017-.75 0-.907-.342-.907-.89V3.638h-2.145v10.494c0 1.54.872 2.397 2.459 2.397.348 0 .68-.069.924-.137m7.886-8.218v4.212c0 1.37-.279 2.123-1.744 2.123-1.465 0-1.744-.754-1.744-2.123V8.174h-2.145v4.777c0 2.55 1.552 3.578 3.89 3.578 2.336 0 3.888-1.027 3.888-3.578V8.174zm5.758 5.599-1.133 1.609c.75.565 1.744 1.147 3.279 1.147 2.092 0 3.191-1.096 3.191-2.585 0-2.893-4.15-2.346-4.15-3.493 0-.205.139-.513.854-.513.453 0 1.133.12 1.866.616l1.133-1.506c-.941-.856-2.284-1.028-3.017-1.028-1.848 0-2.93 1.113-2.93 2.603 0 2.927 4.203 2.174 4.203 3.39 0 .29-.244.598-1.011.598a3.64 3.64 0 0 1-2.285-.838"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 4,
    r: 1,
    fill: "url(#logo-plus-pill_svg__c)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 2.5,
    r: 0.5,
    fill: "url(#logo-plus-pill_svg__d)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 19.5,
    r: 0.5,
    fill: "url(#logo-plus-pill_svg__e)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 8.5,
    r: 0.5,
    fill: "url(#logo-plus-pill_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-plus-pill_svg__g)",
    d: "m55 13 .212 2.788L57 16l-1.788.212L55 19l-.212-2.788L53 16l1.788-.212z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-plus-pill_svg__h)",
    d: "M55.707 15.293 55.15 16l.557.707L55 16.15l-.707.557.557-.707-.557-.707.707.557z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-plus-pill_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(40 0 0 100 12 13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00204D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002A66"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-plus-pill_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 2 -2 0 55 16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#012B67",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-plus-pill_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 20 24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACCCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCCE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-plus-pill_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 .5 -.5 0 48.5 2.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACCCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCCE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-plus-pill_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 16.5 36) scale(.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACCCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCCE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-plus-pill_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 .5 -.5 0 54.5 8.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACCCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCCE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-plus-pill_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 3 -3 0 55 16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACCCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCCE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-plus-pill_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(135 24.186 19.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACCCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCCE",
    stopOpacity: 0
  }))));
};